import React, { useEffect, useState } from 'react';
import { View, TextInput, Pressable } from 'react-native';
import { useLazyQuery } from '@apollo/client';
import styled from 'styled-components/native';
import webStyled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import formatAssetName from '../../utils/formatAssetName';
import Modal from '../../elements/Modal';
import moment from 'moment';

import { Text } from 'app/src/styles';
import * as colors from 'app/src/styles/colors';

import { AUTOCOMPLETE } from './queries';
import BuyerResult from './BuyerResult';

const Container = webStyled.div`
  background-color: white;
  align-self: left;
  align-items: center;
  height: 32px;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 0px;
  border-width: 1px;
  border-style: solid;
  border-color: black;
  min-width: 100px;
  position: relative;
`;

const Input = styled(TextInput)`
  outline-width: 0px;
  outline-color: white;
  margin-left: 12px;
  position: absolute;
  left: 14px;
  top: 6px;
`;

const Results = webStyled.div`
  position: absolute;
  top: 30px;
  left: 5px;
  background-color: white;
  border-width: 1px;
  border-style: solid;
  border-color: black;
  padding-top: 5px;
  width: 200%;
`;

const BuyerAutocompleteContainer = webStyled.div`
`

const IconContainer = webStyled.div`
  position: absolute;
  left: 6px;
  top: 6px;
`;

const BuyerAutocomplete = ({ resource, placeholder, setValue, name, buyer,
  clickedResult, setClickedResult, setShowNewBuyerModal, saleAsset,
  setSaleAssetId, updateSaleAsset
}) => {
  const [term, setTerm] = useState(buyer?.displayName || '');
  const [resources, setResources] = useState([]);
  const [getResults, { data }] = useLazyQuery(
    AUTOCOMPLETE,
    { fetchPolicy: 'no-cache' },
  );

  useEffect(() => {
    if (term && term.length > 2) {
      getResults({ variables: { resource: resource, term: term }});
    }
  }, [term]);

  useEffect(() => {
    if(data) {
      switch(resource) {
        case 'Buyer':
          setResources(data.autocomplete[0].buyers);
          break;
        default:
          break;
      }
    }
  }, [data])

  useEffect(() => {
    const name = buyer?.displayName || '';
    if (term !== name) {
      setTerm(name);
    }
  }, [buyer]);

  return (
    <BuyerAutocompleteContainer>
      <Container>
        {term || clickedResult ? (
          <Pressable onPress={() => {
            setTerm('')

            updateSaleAsset({
              variables: {
                id: saleAsset.id,
                offerAttributes: { buyerId: null }
              }
            });

            setClickedResult();
          }}>
            <IconContainer style={{left: -2}}>
              <FontAwesomeIcon
                icon={faXmark}
                color={colors.disabled}
              />
            </IconContainer>
          </Pressable>
        ) : (
          <IconContainer>
            <FontAwesomeIcon
              icon={faMagnifyingGlass}
              color={colors.disabled}
            />
          </IconContainer>
        )}
        <Input
          placeholder={placeholder}
          placeholderTextColor={colors.disabled}
          value={term}
          onChange={e => setTerm(e.target.value)}
        />
        {term !== buyer?.displayName && showResults()}
      </Container>
    </BuyerAutocompleteContainer>
  );

  function showResults() {
    if(term.length > 2) {
      return (
        <Results id="buyerResults" style={{zIndex: 99999}}>
          {resources?.map(result => (
            <BuyerResult
              key={`${result.__typename}-${result.id}`}
              result={result}
              setTerm={setTerm}
              clickedResult={clickedResult}
              setClickedResult={setClickedResult}
              setShowNewBuyerModal={setShowNewBuyerModal}
              saleAsset={saleAsset}
              setSaleAssetId={setSaleAssetId}
              updateSaleAsset={updateSaleAsset}
            />
          ))}
          <BuyerResult
            key={`create_new`}
            result={{__typename: 'Buyer', id: null, name: term}}
            setTerm={setTerm}
            clickedResult={clickedResult}
            setClickedResult={setClickedResult}
            setShowNewBuyerModal={setShowNewBuyerModal}
            saleAsset={saleAsset}
            setSaleAssetId={setSaleAssetId}
          />
        </Results>
      )
    }
  }
};

export default BuyerAutocomplete;
